import { RouteInterface } from "../interfaces/RouteInterface";
import {RouteDefine} from "./RouteDefine";
import Admin from "../features/private/Admin";

export const adminRoutes : Array<RouteInterface> = [
    { path: RouteDefine.admin, Component: Admin }
]
